var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlagFr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 20,
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 28,
    height: 19,
    stroke: "#5754E5",
    strokeOpacity: 0.15
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0017 1H1V19H10.0017V1Z",
    fill: "#334094"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9998 1H9.99805V19H18.9998V1Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.9997 1H19.001V19H27.9997V1Z",
    fill: "#D61E34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagFr);
export default __webpack_public_path__ + "static/media/flagFR.1258add77b066d040d4c74f8d8d38902.svg";
export { ForwardRef as ReactComponent };